var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99967 0.833313C4.93706 0.833313 0.833008 4.93737 0.833008 9.99998C0.833008 15.0626 4.93706 19.1666 9.99967 19.1666C15.0623 19.1666 19.1663 15.0626 19.1663 9.99998C19.1663 4.93737 15.0623 0.833313 9.99967 0.833313ZM14.3389 8.08924C14.6644 7.7638 14.6644 7.23616 14.3389 6.91072C14.0135 6.58529 13.4859 6.58529 13.1604 6.91072L8.74967 11.3215L6.83893 9.41072C6.51349 9.08529 5.98586 9.08529 5.66042 9.41072C5.33498 9.73616 5.33498 10.2638 5.66042 10.5892L8.16042 13.0892C8.48586 13.4147 9.01349 13.4147 9.33893 13.0892L14.3389 8.08924Z",
    fill: "#16B364"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.44cf8f1c555e5f23a9844c87aedc1558.svg";
export { ForwardRef as ReactComponent };